const e = {
  xsmall: {
    widthAndHeight: "24px",
    imageSize: "16px",
    insetAndBorderWidth: "xxxsmall",
    secondaryCircleSize: "11px",
    secondaryCirclePadding: "xxsmall"
  },
  small: {
    widthAndHeight: "32px",
    imageSize: "22px",
    insetAndBorderWidth: "xxxsmall",
    secondaryCircleSize: "13px",
    secondaryCirclePadding: "xsmall"
  },
  medium: {
    widthAndHeight: "48px",
    imageSize: "32px",
    insetAndBorderWidth: "xxsmall",
    secondaryCircleSize: "18px",
    secondaryCirclePadding: "small"
  },
  large: {
    widthAndHeight: "64px",
    imageSize: "44px",
    insetAndBorderWidth: "xxsmall",
    secondaryCircleSize: "26px",
    secondaryCirclePadding: "medium"
  },
  xlarge: {
    widthAndHeight: "84px",
    imageSize: "64px",
    insetAndBorderWidth: "xxsmall",
    secondaryCircleSize: "37px",
    secondaryCirclePadding: "medium"
  },
  fill: {
    widthAndHeight: "100%",
    imageSize: "75%",
    insetAndBorderWidth: "xxsmall",
    secondaryCircleSize: "37px",
    secondaryCirclePadding: "medium"
  }
};
export {
  e as avatarSizeToStylesMap
};
